import { combineReducers, createReducer } from '@reduxjs/toolkit';

import { clearAutocompleteQuery, setAutocompleteQuery } from 'Core/actions/autocomplete';
import { setResponse } from 'Core/actions/response';
import { fromPayload } from 'Core/reducers/common';

export default combineReducers({
  query: createReducer('', (builder) =>
    builder
      .addCase(clearAutocompleteQuery, () => '')
      .addCase(setAutocompleteQuery, fromPayload)
      .addCase(setResponse, (_state, { payload: { Query } }) => Query ?? ''),
  ),
});
